import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { sendAnalytics } from 'client/scripts/utils/analyticsUtils';
import SessionAttachments from './sessionSections/SessionAttachments';
import SessionSponsors from './sessionSections/SessionSponsors';
import SessionSpeakers from './sessionSections/speakers/SessionSpeakersSessionPage';
import { useInterval } from './sessionBroadcastUtils';
import { UPDATE_LIVE_SESSIONS_INTERVAL } from './AgendaConstants';
import { useSessionElements } from './hooks/useSessionElements';
import FeatureToggleUtils from 'FeatureToggleUtils';

const SessionView = (props) => {
    const {
        session,
        speakers,
        siteConf,
        showCompactLists,
        displayInContainer,
        stickSectionsToLeft,
        isRingAvailable
    } = props;
    const sendAttachmentDownloadAnalytics = ({type, url, name}) => {
        sendAnalytics('downloadAttachment', {
            sessionId: session?.id,
            attachment: {
                type,
                url,
                name,
            }
        });
    };

    // To make sure the session re-renders the join button when it becomes live
    const [currentDate, setCurrentDate] = useState(null);
    useInterval(() => {
        setCurrentDate(Date.now());
    }, UPDATE_LIVE_SESSIONS_INTERVAL);

    const pageElementClass = classnames('session-page session-page-element padding-bottom-small');

    const sessionPageDynamicSizeEnabled = FeatureToggleUtils.isFeatureEnabled(
        'rollout-virtual-enable-classic-agenda-session-virtual-element-dynamic-size'
    );
    const { virtualSectionElement, sessionInfoElement } = useSessionElements({...props, pageElementClasses: pageElementClass, displayInContainer: displayInContainer, isDynamicSizeEnabled: sessionPageDynamicSizeEnabled});

    return (
        <div className='session-page-wrapper'>
            <div
                className={classnames('session-page-elements-container', { 'dynamic-size': sessionPageDynamicSizeEnabled })}>
                {sessionInfoElement}
                {virtualSectionElement}
                <div className={classnames(pageElementClass, 'margin-bottom-small transparentContainer', { 'container': !sessionPageDynamicSizeEnabled })}>
                    <SessionSpeakers
                        session={session}
                        speakers={speakers}
                        siteConf={siteConf}
                        showCompactLists={showCompactLists}
                        stickSectionsToLeft={stickSectionsToLeft} />

                    <SessionSponsors
                        session={session}
                        siteConf={siteConf}
                        showCompactLists={showCompactLists}
                        stickSectionsToLeft={stickSectionsToLeft}
                        displayInContainer={displayInContainer} />

                    {!isRingAvailable && <SessionAttachments
                        attachments={session?.attachments}
                        attachmentsTitle={session?.attachmentsTitle}
                        sendAnalytics={sendAttachmentDownloadAnalytics}
                        showCompactLists={showCompactLists}
                        stickSectionsToLeft={stickSectionsToLeft}
                        sessionId={session?.id}
                    />}
                </div>
            </div>
        </div>
    );
};

SessionView.propTypes = {
    session: PropTypes.object,
    settings: PropTypes.object,
    event: PropTypes.object,
    siteConf: PropTypes.object,
    speakers: PropTypes.object,
    isSessionRegistrationEnabled: PropTypes.bool.isRequired,
    me: PropTypes.object,
    isRegistered: PropTypes.bool,
    eventUrls: PropTypes.object.isRequired,
    toggleMarker: PropTypes.func.isRequired,
    showEmailLogin: PropTypes.func.isRequired,
    showControlPanel: PropTypes.bool,
    displayInContainer: PropTypes.bool,
    showCompactLists: PropTypes.bool,
    shouldUseCompactDescription: PropTypes.bool,
    stickSectionsToLeft: PropTypes.bool,
    sessionViewType: PropTypes.string.isRequired,
    toggleSessionRegistrationStatusPerSession: PropTypes.func,
    openCloseTicketSelectionPopUp: PropTypes.func,
    ticketsSelectionData: PropTypes.object.isRequired,
    setSessionFullRegistration: PropTypes.func,
    setVirtualSessionDetails: PropTypes.func,
    currentVirtualSessionDetails: PropTypes.object,
    setRecordUrl: PropTypes.func,
    recordUrl: PropTypes.string,
    setScrollToSessionBroadcastAction: PropTypes.func,
    sendRate: PropTypes.func,
    feedback: PropTypes.string,
    rate: PropTypes.number,
    scrollToBroadcast: PropTypes.bool,
    isWebLoginV2Used: PropTypes.bool,
    accessErrorType: PropTypes.string,
    isRingAvailable: PropTypes.bool,
};


export default SessionView;
